import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
} from "shared-utility/store/utils/helpers";

// ACTIONS

export const QUOTES_GET_QUOTES = generateDefaultActions("QUOTES_GET_QUOTES");
export const quotesGetQuotes = payload => makePayload(QUOTES_GET_QUOTES.value, payload);
function* quotesGetQuotesSaga(payload) {
  const url = `/quotes/deal/${payload.dealId}`;
  yield requestSaga(QUOTES_GET_QUOTES, url, "GET");
}

// REDUCER

const initialState = {
  quotes: {}
};

export function quotesReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case QUOTES_GET_QUOTES.success:
      return defaultReturn(state, payload.data, "quotes");

    default:
      return state;
  }
}

// SAGA

export function* quotesSaga() {
  yield takeLatest(QUOTES_GET_QUOTES.value, quotesGetQuotesSaga);
}
